<template>
  <div class="purchaseDetail">
    <van-skeleton title v-if="showDetail" :row="12" />
    <div v-else>
      <div class="part part1">
        <div class="title">
          <span>进货信息</span>
        </div>
        <div class="text">批次编号：{{detailData.batch_no}}</div>
        <div class="text">货主名称：{{detailData.supplier_name}}</div>
        <div class="text">进货量：{{ detailData.batch_weight_kg*1}}公斤</div>
        <div class="text">商品金额：{{detailData.batch_amount|numToFixed(2)}}元</div>
        <div class="text">总附加费：{{detailData.surcharge_amount|numToFixed(2)}}元</div>
        <div class="text">总成本：{{detailData.goods_surcharge_amount_total|numToFixed(2)}}元</div>
        <div class="date">进货时间：{{detailData.created_at | toTime}}</div>
      </div>
      <div class="part part2" v-if="detailData.goods.length">
        <div class="title">
          <span>货品明细</span>
        </div>
        <div class="text good_title" v-for="(item,index) in detailData.goods" :key="index">
          <div class="titles">
            <span style="margin-right:0.2rem">{{item.name}}</span>
            <div class="good_type good_type_0" v-if="item.bale == 3">
              散装
              <img src="./../../../../assets/img/work/open_order/order/type_sanzhuang.png" alt />
            </div>
            <div v-if="item.bale == 1" class="good_type good_type_1">
              定装
              <img src="./../../../../assets/img/work/open_order/order/type_dingzhuang.png" alt />
            </div>
            <div class="good_type good_type_2" v-if="item.bale == 2">
              非定装
              <img
                src="./../../../../assets/img/work/open_order/order/type_feidingzhuang.png"
                alt
              />
            </div>
            <div class="good_type good_type_3" v-if="item.type==1">自营</div>
            <div class="good_type good_type_5" v-else>代卖</div>
          </div>
          <template v-if="item.bale==1">
            <div class="text">单价：{{item.price}}元 /{{unit_list[item.num_unit-1].name}}</div>
            <div class="text">规格：{{item.bale_num*1}}公斤/{{unit_list[item.num_unit-1].name}}</div>
          </template>
          <template v-if="item.bale!=1">
            <div class="text">单价：{{item.price}}元/公斤</div>
          </template>
          <div class="text" v-if="item.bale!=3">数量：{{item.num*1}}{{unit_list[item.num_unit-1].name}}</div>

          <div v-if="item.bale!=1">重量：{{item.weight*1}}公斤</div>
          <div class="text text_status">
            状态：
            <van-tag type="success" v-if="item.status==1">销售中</van-tag>
            <van-tag type="danger" v-if="item.status==2">告罄</van-tag>
            <van-tag type="warning" v-if="item.status=='-1'">已删除</van-tag>
          </div>
          <div class="text">
            附加费用：
            <span v-if="!item.goodsSurcharge.length">暂无</span>
            <div v-else class="table">
              <div class="flex_b" style="margin-top:0.2rem">
                <div class="flex_first bold">产品附加费</div>
                <div class="flex_end bold">金额</div>
              </div>
              <div v-for="(citem,j) in item.goodsSurcharge" :key="j" class="flex_b">
                <div class="flex_first">{{citem.name}}</div>
                <div class="flex-end">￥{{citem.price}}</div>
              </div>

              <div class="text" style="margin-bottom:0.2rem">
                <span style="font-weight:600">合计：</span>
                ￥{{item.surcharge_amount}}
              </div>
            </div>
          </div>

          <div>商品金额：{{item.amount}}元</div>
          <div>成本：{{item.goods_surcharge_amount}}元</div>
        </div>
      </div>
      <div class="part part3">
        <div class="part3_box">
          <div class="title">产地附加费：</div>
          <div v-if="detailData.placeArr.length" class="part3_table">
            <div v-for="(kitem,ki) in detailData.placeArr" :key="ki" class="flex_b">
              <div class="flex-first">{{kitem.name}}</div>
              <div class="flex-end">￥{{kitem.price|numToFixed(2)}}</div>
            </div>
          </div>
          <div class="text_tip" v-else>暂无数据</div>
        </div>
        <div class="part3_box">
          <div class="title">市场附加费：</div>
          <div v-if="detailData.marketArr.length" class="part3_table">
            <div v-for="(kitem,ki) in detailData.marketArr" :key="ki" class="flex_b">
              <div class="flex-first">{{kitem.name}}</div>
              <div class="flex-end">￥{{kitem.price|numToFixed(2)}}</div>
            </div>
          </div>
          <div class="text_tip" v-else>暂无数据</div>
        </div>
        <div class="text">
          合计：
          <span style="font-weight:500">￥{{detailData.batchsurcharge_amount}}</span>
        </div>
      </div>

      <div class="part part4" v-if="detailData.prod_cert_imgs.length">
        <div class="title">产地证明</div>
        <div>
          <van-image
            :width="'100%'"
            v-for="(item,i) in detailData.prod_cert_imgs"
            :key="i"
            none
            :src="item"
            @click="ImgPreView(i,'prod_cert_imgs')"
          />
        </div>
      </div>
      <div class="part part5" v-if="detailData.bill_cert_imgs.length">
        <div class="title">销售凭证</div>
        <div>
          <van-image
            :width="'100%'"
            v-for="(item,i) in detailData.bill_cert_imgs"
            :key="i"
            none
            :src="item"
            @click="ImgPreView(i,'bill_cert_imgs')"
          />
        </div>
      </div>
    </div>

    <van-image-preview
      v-model="showPreview"
      :start-position="imgIndex"
      :images="imgArr"
      @change="changeImgIndex"
    >
      <template v-slot:index>{{ imgIndex+1 }}/{{imgArr.length}}</template>
    </van-image-preview>
  </div>
</template>

<script>
import { purchase_Detail } from "@/api/work/manage/purchase.js";
import { timestampToTime } from "@/utils/timestamp";
export default {
  name: "purchaseDetail",
  data() {
    return {
      imgArr: [],
      showPreview: false,
      imgIndex: 1,
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      listQuery: {
        batch_id: ""
      },
      detailData: {},
      showDetail: true
    };
  },
  filters: {
    numToFixed(num, val = 2) {
      return (num * 1).toFixed(val);
    },
    toTime(t) {
      return timestampToTime(t);
    },
    goodsSurcharge(arr) {
      return arr
        .reduce((total, it) => {
          return total + it.price * 1;
        }, 0)
        .toFixed(2);
    }
  },
  created() {
    if (this.$route.query.id) {
      this.listQuery.batch_id = this.$route.query.id;
      this.getList();
    }
  },
  mounted() {},
  methods: {
    // 图片预览索引改变
    changeImgIndex(i) {
      this.imgIndex = i;
    },
    // 图片预览
    ImgPreView(i, name) {
      this.imgArr = this.detailData[name];
      this.showPreview = true;
      this.imgIndex = i;
    },
    //请求详情
    getList() {
      purchase_Detail(this.listQuery).then(res => {
        if (res.code == 200) {
          this.showDetail = false;
          let market = [];
          let place = [];
          res.data.batchSurcharge.forEach(ele => {
            if (ele.type == 1) {
              place.push(ele);
            } else {
              market.push(ele);
            }
          });
          delete res.data.batchSurcharge;
          res.data.marketArr = market;
          res.data.placeArr = place;
          if (!res.data.bill_cert_imgs) {
            res.data.bill_cert_imgs = [];
          } else if (res.data.bill_cert_imgs.indexOf(",")) {
            res.data.bill_cert_imgs = res.data.bill_cert_imgs.split(",");
          } else {
            res.data.bill_cert_imgs = [res.data.bill_cert_imgs];
          }
          if (!res.data.prod_cert_imgs) {
            res.data.prod_cert_imgs = [];
          } else if (res.data.prod_cert_imgs.indexOf(",")) {
            res.data.prod_cert_imgs = res.data.prod_cert_imgs.split(",");
          } else {
            res.data.prod_cert_imgs = [res.data.prod_cert_imgs];
          }

          this.detailData = res.data;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.purchaseDetail {
  position: relative;
  padding-bottom: 0.3rem;

  .part {
    padding: 0.31rem 0.3rem 0.3rem 0.31rem;
    width: 6.9rem;
    border-radius: 0.16rem;
    margin: 0.2rem auto 0;
    background: #fff;
    box-sizing: border-box;
    .title {
      font-size: 0.36rem;
      font-weight: bold;
      margin: 0 0 0.1rem;
    }
    .table {
      padding-left: 0.5rem;
    }
    .date {
      font-size: 0.28rem;
      color: rgb(153, 153, 153);
      padding-top: 0.1rem;
      margin-top: 0.1rem;
      border-top: 1px solid rgb(245, 245, 245);
    }
    .text {
      font-size: 0.32rem;
      line-height: 0.51rem;
      .titles {
        > span {
          font-weight: 600;
          line-height: 0.6rem;
        }
      }
    }
  }

  .part3 {
    .part3_table {
      margin: 0.2rem 0 0;
      padding-left: 0.5rem;
      font-size: 0.32rem;
    }
    .text_tip {
      font-size: 0.36rem;
      text-align: center;
      color: #ccc;
      line-height: 0.51rem;
    }
    .part3_box {
      padding-bottom: 0.2rem;
      border-bottom: 1px solid rgb(245, 245, 245);
      margin-bottom: 0.2rem;
    }
  }
  .part2 {
    .good_title {
      margin-top: 0.3rem;
      border: 2px solid #32b258;
      padding: 0.2rem;
      box-sizing: border-box;
      border-radius: 0.15rem;
    }
    .bold {
      font-weight: 600;
    }
  }
  .flex_b {
    display: flex;
    justify-content: space-between;
    .flex_first {
      flex-grow: 0;
      flex-shrink: 0;
    }
    .flex_end {
      flex-grow: 1;
      text-align: right;
    }
  }
  .good_type {
    display: inline-block;
    vertical-align: baseline;
    padding: 0 0.18rem;
    height: 0.5rem;
    line-height: 0.5rem;
    border-radius: 0.25rem;
    margin-right: 0.2rem;
    &.good_type_0 {
      background-color: #dafbdb;
      color: #4b9c64;
    }
    &.good_type_1 {
      background-color: #daeffb;
      color: #1d78c5;
    }
    &.good_type_2 {
      background-color: #fbedda;
      color: #bf8535;
    }
    &.good_type_3 {
      background: rgba(28, 192, 233, 0.3);
      color: #268ea7;
    }
    &.good_type_5 {
      background: rgba(233, 153, 28, 0.3);
      color: #c6601c;
    }
    img {
      width: 0.22rem;
      height: 0.22rem;
      margin-left: 0.1rem;
    }
  }
  .text_status{
    span{
      vertical-align: text-bottom;
    }
  }
}
</style>